<template>
  <v-card>
    <v-toolbar flat color="white" density="compact">
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="selected_category"
          :return-object="false"
          :items="categories"
          hide-details
          single-line>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('category') }}</span>
        </template>
      </v-autocomplete>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="selected_subcategory"
          :return-object="false"
          :items="subcategories[selected_category]"
          hide-details
          single-line>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('subcategory') }}</span>
        </template>
      </v-autocomplete>
      <!--RIGHT PART START (BUTTONS)-->
      <v-spacer/>
      <div class="chip-container">
        <!--CREATE PROJECT MANAGEMENT QUESTION-->
        <base-action-button v-if="canCreate" @action="$emit('create', [selected_category, selected_subcategory])">
          <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("create") }}
        </base-action-button>
        <!--SAVE-->
        <base-action-button v-if="canEdit" @action="save()">
          <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
          {{ $store.getters.translate("save") }}
        </base-action-button>
      </div>
    </v-toolbar>
    <v-data-table
        id="base_table_project_management_questions"
        :headers="headers"
        :items="getRecords"
        class="elevation-1"
        show-select
        :items-per-page="100">
      <template #header.data-table-select>
        <v-chip variant="outlined" class="bulk-chip" rounded="pill" size="large" density="comfortable">
          <v-menu :disabled="selected.length === 0">
            <template #activator="{ props: menuProps, isActive }">
              <div class="chip-content">
                <v-checkbox
                    :model-value="selected.length > 0 && selected.length === getRecords.length"
                    :indeterminate="selected.length > 0 && selected.length < getRecords.length"
                    @click="toggleSelectAll"
                    color="success"
                    hide-details/>
                <v-btn v-bind="menuProps" v-if="selected.length" icon class="arrow-btn" elevation="0">
                  <PhCaretUp v-if="isActive" size="20"/>
                  <PhCaretDown v-else size="20"/>
                </v-btn>
              </div>
            </template>
            <v-list v-if="selected.length > 0">
              <!--DELETE-->
              <v-list-item v-if="canDelete" @click.stop="bulkArchive">
                <template #prepend><PhTrash size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate("delete") }} {{ selected.length }} {{ $store.getters.translate(page.name) }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-chip>
      </template>
      <template #body="{ items }">
        <draggable :disabled="!canEdit" :list="items" tag="tbody" @end="endDrag(items)" item-key="id">
          <template #item="{ element: question }">
            <tr class="sm-normal text-primary">
              <td><v-checkbox v-model="selected" :value="question" hide-details color="success" density="compact"/></td>
              <td><PhArrowsVertical size="20" weight="bold" style="cursor: pointer; vertical-align: middle;" /></td>
              <td>{{ question.sort_order }}</td>
              <td><a class="sm-bold" @click="$emit('edit', question)">{{ question.name }}</a></td>
              <td>{{ question.category }}</td>
              <td>{{ question.subcategory }}</td>
              <!--ACTION BUTTONS-->
              <td style="text-align: center; width: 80px;" v-if="canEdit || canDelete">
                <v-menu>
                  <template #activator="{ props }">
                    <v-btn elevation="0" icon v-bind="props">
                      <PhDotsThreeVertical size="24" style="cursor: pointer;" />
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="canEdit" @click="$emit('edit', question)">
                      <template #prepend><PhPencilSimpleLine size="24" /></template>
                      <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('edit') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="canDelete" @click="deleteRecord(question.id)">
                      <template #prepend><PhTrash size="24" /></template>
                      <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </draggable>
      </template>
      <template #bottom />
    </v-data-table>
  </v-card>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions.js";
import draggable from "vuedraggable";
import BaseActionButton from "./BaseActionButton";
import { PhArrowsVertical, PhDotsThreeVertical, PhFloppyDisk, PhPencilSimpleLine, PhPlus, PhTrash, PhCaretUp, PhCaretDown } from "@phosphor-icons/vue";

export default {
  components: { draggable, BaseActionButton, PhArrowsVertical, PhTrash, PhPencilSimpleLine, PhDotsThreeVertical, PhFloppyDisk, PhPlus, PhCaretUp, PhCaretDown },
  setup() {
    const { can } = useAbility()
    return { can }
  },
  data() {
    return {
      page: helpFunctions.pages.projectmanagementquestions,
      all_records: [],
      records: [],
      headers: helpFunctions.headers.project_management_questions_and_answers,
      categories: [],
      subcategories: [],
      selected: [],
      selected_category: "Project Engineer",
      selected_subcategory: "Initiate phase (CP0+CP1)",
    };
  },
  beforeMount() {
    document.querySelector('#base_table_project_management_questions > .v-table__wrapper > table > tbody')?.remove();
  },
  mounted() {
    const sortableTbody = document.querySelector('#base_table_project_management_questions > .v-table__wrapper > table > tbody > tbody');
    // <draggable> ruin view in <tbody> (create a <div> tag inside <tbody>)
    //FIX: https://github.com/SortableJS/Vue.Draggable/issues/1212#issuecomment-1918880591
    if (sortableTbody) {
      const tbody = document.querySelector('#base_table_project_management_questions > .v-table__wrapper > table > tbody')
      tbody.parentNode.append(sortableTbody);
      tbody.remove()
    }
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.records = [];
      this.all_records = [];
      let response = await helpFunctions.getModelsForTables(this.$toast, this.page.name);
      this.all_records = this.$lodash.sortBy(response.data, 'sort_order');
      this.all_records.forEach((question) => {
        if(!this.categories.includes(question.category)) {
          this.categories.push(question.category);
        }
        if(!this.subcategories[question.category]) {
          this.subcategories[question.category] = [];
        }
        if(!this.subcategories[question.category].includes(question.subcategory)) {
          this.subcategories[question.category].push(question.subcategory);
        }
      });
      this.showRecords();
    },
    showRecords() {
      this.records = [];
      for (let i = 0; i < this.all_records.length; i++) {
        if (this.all_records[i].category.toLowerCase() === this.selected_category.toLowerCase() &&
            this.all_records[i].subcategory.toLowerCase() === this.selected_subcategory.toLowerCase()) {
          this.records.push(this.all_records[i]);
        }
      }
    },
    save() {
      for (let i = 0; i < this.records.length; i++) {
        helpFunctions.saveModelSilently(this.page.name, this.records[i]);
      }
      this.$toast.success(this.$store.getters.translate("successfully_saved"));
    },
    endDrag(items) {
      let temp_records = this.records;
      for (let i = 0; i < temp_records.length; i++) {
        for (let z = 0; z < items.length; z++) {
          if (temp_records[i].id === items[z].id && temp_records[i].sort_order !== z + 1) {
            this.records[i].sort_order = z + 1;
          }
        }
      }
      this.records.sort((a, b) => a.sort_order - b.sort_order); // The table was not re-sorted in the previous algorithm, although the values were changed correctly.
    },
    async deleteRecord(id) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, id);
          await this.load();
        }
      });
    },
    toggleSelectAll() {
      const currentValues = this.records;
      const allSelected = currentValues.every(cv =>
          this.selected.some(sel => sel.id === cv.id)
      );
      if (allSelected) {
        this.selected = this.selected.filter(item =>
            !currentValues.some(cv => cv.id === item.id)
        );
      }
      else {
        const selectedIds = new Set(this.selected.map(item => item.id));
        console.log(currentValues)
        const toAdd = currentValues.filter(cv => !selectedIds.has(cv.id));
        this.selected = [...this.selected, ...toAdd];
      }
    },
    async bulkArchive() {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.postCustomRoute(this.$toast, "bulk/remove", { model: this.page.model, ids: this.$lodash.map(this.selected, "id") }, true, true);
          this.selected = [];
          await this.load();
        }
      });
    },
  },
  computed: {
    getRecords() {
      if(this.records) {
        return this.records;
      }
      else {
        return [];
      }
    },
    canCreate() {
      return this.can("create", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canEdit() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
  },
  watch: {
    selected_category: {
      handler() {
        this.selected_subcategory = this.subcategories[this.selected_category][0];
        this.showRecords();
      },
    },
    selected_subcategory: {
      handler() {
        this.showRecords();
      },
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}
.v-text-field >>> input {
  font-size: 12px !important;
}
.v-text-field >>> label {
  font-size: 12px !important;
}
.bulk-chip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-color: rgba(var(--v-theme-primary), 0.3);
  padding: 0px !important;
}
.chip-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.chip-container {
  display: flex;
  gap: 8px;
  margin-right: 16px;
}
.arrow-btn {
  width: 36px;
  height: 36px;
  min-width: 0;
  background-color: transparent;
}
</style>